module.exports = __webpack_public_path__ + "static/media/kerstman-door-het-ijs-3.0984e4ff.jpeg";